export default __webpack_public_path__ + "strong-signal-icon.png";